$(function() {

    var html5player = {
        init(auditionUrl) {
            var _this = this;
            this.$audioplayer = $('#product-audio-player');
            this.auditionUrl = auditionUrl ? auditionUrl : this.$audioplayer.data('audition-url');
            if (!this.auditionUrl || this.auditionUrl == '') {
                return;
            }
            this.duration;
            this.createDomPlayer = this.createDomPlayer.bind(this);
            this.bindPlayerEvents = this.bindPlayerEvents.bind(this);
            this.moveplayhead = this.moveplayhead.bind(this);
            this.timeLineClick = this.timeLineClick.bind(this);
            this.clickPercent = this.clickPercent.bind(this);
            this.getPosition = this.getPosition.bind(this);
            // this.mouseDown = this.mouseDown.bind(this);
            // this.mouseUp = this.mouseUp.bind(this);
            this.timeUpdate = this.timeUpdate.bind(this);
            this.play = this.play.bind(this);
            $.get(auditionUrl).done(function() {
                _this.createDomPlayer();
                _this.bindPlayerEvents();
            });
        },
        createDomPlayer() {
            this.$label = $('<div class="label">Hörprobe:</div>');
            this.$nativePlayer = $('<audio class="native-player" preload="true"><source src="'+this.auditionUrl+'" type="audio/mp3"></audio>');
            this.$player = $('<div class="player"></div>');
            this.$button = $('<button type="button"></button>');
            this.$timeline = $('<div class="timeline"></div>');
            this.$playhead = $('<div class="playhead"></div>');
            this.$playIcon = $('<i class="fas fa-play"></i>');
            this.$pauseIcon = $('<i class="fas fa-pause"></i>');
            this.$timeline.append(this.$playhead);
            this.$button.append(this.$playIcon);
            this.$player.append(this.$button);
            this.$player.append(this.$timeline);
            this.$audioplayer.append(this.$label);
            this.$audioplayer.append(this.$nativePlayer);
            this.$audioplayer.append(this.$player);
            this.timelineWidth = this.$timeline.width() - this.$playhead.width();
        },
        moveplayhead(e) {
            var newMargLeft = e.clientX - this.getPosition();
            if (newMargLeft >= 0 && newMargLeft <= this.timelineWidth) {
                this.$playhead.css('width', newMargLeft + "%");
            }
            if (newMargLeft < 0) {
                this.$playhead.css('width', "0%");
            }
            if (newMargLeft > this.timelineWidth) {
                this.$playhead.css('width', this.timelineWidth + "%");
            }
        },
        getPosition() {
            return this.$timeline[0].getBoundingClientRect().left;
        },
        clickPercent(e) {
            // returns click as decimal (.77) of the total timelineWidth
            return (e.clientX - this.getPosition()) / this.timelineWidth;
        },
        timeLineClick(e) {
            this.moveplayhead(e);
            this.$nativePlayer[0].currentTime = this.duration * this.clickPercent(e);
        },
        // mouseDown() {
        //     this.onplayhead = true;
        //     window.addEventListener('mousemove', this.moveplayhead, true);
        //     $nativePlayer.bind('timeupdate', this.timeUpdate, false);
        // },
        // mouseUp(e) {
        //     console.log('mouseUp');
        //     if (this.onplayhead == true) {
        //         this.moveplayhead(e);
        //         window.removeEventListener('mousemove', this.moveplayhead, true);
        //         this.$nativePlayer[0].currentTime = this.duration * this.clickPercent(e);
        //         this.$nativePlayer.bind('timeupdate', this.timeUpdate, false);
        //     }
        //     this.onplayhead = false;
        // },
        timeUpdate() {
            var playPercent = 100 * (this.$nativePlayer[0].currentTime / this.duration);
            this.$playhead.css('width', playPercent + "%");
            if (this.$nativePlayer[0].currentTime == this.duration) {
                this.$button.html(this.$playIcon);
                this.$nativePlayer[0].currentTime = 0;
            }
        },
        play() {
            if (this.$nativePlayer[0].paused) {
                this.$nativePlayer[0].play();
                this.$button.html(this.$pauseIcon);
            } else {
                this.$nativePlayer[0].pause();
                this.$button.html(this.$playIcon);
            }
        },
        bindPlayerEvents() {
            var _this = this;
            this.$nativePlayer[0].load();
            this.$nativePlayer[0].addEventListener("canplaythrough", function() {
                _this.duration = _this.$nativePlayer[0].duration;
            }, false);
            this.$button.on("click", this.play);
            this.$nativePlayer.bind("timeupdate", this.timeUpdate);
            this.$timeline.on("click", this.timeLineClick);
            // makes playhead draggable
            // this.$playhead.on('mousedown', this.mouseDown, false);
            // window.addEventListener('mouseup', this.mouseUp, false);
            // Boolean value so that audio position is updated only when the playhead is released
            // this.onplayhead = false;
        },
        destroy() {
            if (this.$nativePlayer && this.$nativePlayer.length) {
                this.$nativePlayer[0].removeEventListener("canplaythrough", function() {
                    _this.duration = _this.$nativePlayer[0].duration;
                }, false);
            }
            if (this.$button && this.$button.length) {
                this.$button.off("click", this.play);
            }
            if (this.$nativePlayer && this.$nativePlayer.length) {
                this.$nativePlayer.unbind("timeupdate", this.timeUpdate);
            }
            if (this.$timeline && this.$timeline.length) {
                this.$timeline.off("click", this.timeLineClick);
            }
            this.auditionUrl = undefined;
            this.duration = undefined;
            if (this.$audioplayer && this.$audioplayer.length) {
                this.$audioplayer.empty();
            }
            this.$label = undefined;
            this.$nativePlayer = undefined;
            this.$player = undefined;
            this.$button = undefined;
            this.$timeline = undefined;
            this.$playhead = undefined;
            this.$playIcon = undefined;
            this.$pauseIcon = undefined;
            this.timelineWidth = undefined;
            this.$audioplayer = undefined;
        }
    }

    window.auditionPlayer = html5player;

    if ($('#product-audio-player').length) {
        window.auditionPlayer.init();
    }

});